import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  writeBatch,
} from "firebase/firestore";
import { db } from "../firebase";

export const COLUMNS = [
  { id: "backlog", label: "Backlog" },
  { id: "in_progress", label: "In progress" },
  { id: "review", label: "Review" },
  { id: "done", label: "Done" },
  { id: "bugs", label: "Bugs" },
];

export const isValidColumn = (c) => COLUMNS.some((col) => col.id === c);

const tasksCol = (projectId) => collection(db, "projects", projectId, "tasks");

export const subscribeTasks = (projectId, cb) =>
  onSnapshot(query(tasksCol(projectId), orderBy("order", "asc")), (snap) =>
    cb(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
  );

export const createTask = (projectId, { title, description, column = "backlog", authorUid }) =>
  addDoc(tasksCol(projectId), {
    title,
    description: description || "",
    column,
    order: Date.now(),
    authorUid: authorUid || null,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    movedByUid: authorUid || null,
    movedAt: serverTimestamp(),
  });

export const updateTask = (projectId, taskId, patch) =>
  updateDoc(doc(db, "projects", projectId, "tasks", taskId), {
    ...patch,
    updatedAt: serverTimestamp(),
  });

export const deleteTask = (projectId, taskId) =>
  deleteDoc(doc(db, "projects", projectId, "tasks", taskId));

// Apply the full post-drop ordering. `ordered` is a flat array of tasks in
// their new visual order, each already carrying its intended `column`.
// We rewrite `order` as the index, so rows stay sorted globally.
export const reorderTasks = async (projectId, ordered, authorUid) => {
  const batch = writeBatch(db);
  ordered.forEach((t, idx) => {
    batch.update(doc(db, "projects", projectId, "tasks", t.id), {
      order: idx,
      column: t.column,
      updatedAt: serverTimestamp(),
      movedByUid: authorUid || null,
      movedAt: serverTimestamp(),
    });
  });
  await batch.commit();
};
